import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

const isDev = process.env.NODE_ENV !== 'production'

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_API_ENDPOINT
})

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: isDev
})

export default client
